// Exports the "formatpainter" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/formatpainter')
//   ES2015:
//     import 'tinymce/plugins/formatpainter'
require('./plugin.min.js')
